import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ExpertModal from './ExpertModal';
import QuoteModal from './QuoteModal'; // <-- 1. Import QuoteModal

export default function Nav({ onQuote, onExpert }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 768 : true
  );

  const [internalExpertOpen, setInternalExpertOpen] = useState(false);
  const [internalQuoteOpen, setInternalQuoteOpen] = useState(false); // <-- 2. Add quote internal state

  const handleOpenExpert = () => {
    if (onExpert) {
      onExpert();
    } else {
      setInternalExpertOpen(true);
    }
  };

  // <-- 3. Add handleOpenQuote fallback
  const handleOpenQuote = () => {
    if (onQuote) {
      onQuote();
    } else {
      setInternalQuoteOpen(true);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const companyName = "eMedha";

  const navLinks = [
    { label: 'Flights', path: '/flights' },
    { label: 'Tours', path: '/tours' },
    { label: 'Visa', path: '/visa' },
    { label: 'Corporate', path: '/corporate' },
    { label: 'Hotels', path: '/hotels' },
  ];

  const rightLinks = [
    { label: 'About Us', path: '/about' },
    { label: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavigate = (path) => {
    setMobileOpen(false);
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleHome = () => {
    setMobileOpen(false);
    navigate('/');
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <header style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, transition: 'all 0.3s ease', background: scrolled ? 'rgba(0,0,0,0.98)' : 'rgba(0,0,0,0.6)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderBottom: scrolled ? '1px solid rgba(244,123,32,0.15)' : 'none' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', height: '64px', gap: '32px' }}>

          <button type="button" onClick={handleHome} aria-label="Go to home" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginRight: '16px', flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
            <div
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 700,
                background: 'var(--gold, #f47b20)',
                color: 'var(--navy, #0a192f)',
                fontFamily: 'Manrope, sans-serif'
              }}
            >
              {companyName.charAt(0).toUpperCase()}
            </div>

            <span
              style={{
                color: '#ffffff',
                fontWeight: 700,
                fontSize: '15px',
                letterSpacing: '0.025em',
                fontFamily: 'Manrope, sans-serif'
              }}
            >
              {companyName.toUpperCase()}
              <span style={{ color: 'var(--gold, #f47b20)' }}> TRAVELS</span>
            </span>

          </button>

          {isDesktop && (
            <nav style={{ display: 'flex', alignItems: 'center', gap: '4px', flex: 1 }}>
              {navLinks.map((link) => (
                <button type="button" key={link.path} onClick={() => handleNavigate(link.path)} style={{ padding: '6px 12px', borderRadius: '4px', fontSize: '13px', fontWeight: 500, border: 'none', cursor: 'pointer', transition: 'color 0.2s, background-color 0.2s', fontFamily: 'Manrope, sans-serif', color: isActive(link.path) ? 'var(--gold, #f47b20)' : 'rgba(255,255,255,0.85)', background: isActive(link.path) ? 'rgba(244,123,32,0.1)' : 'transparent' }}>{link.label}</button>
              ))}
            </nav>
          )}

          {isDesktop && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginLeft: 'auto' }}>
              {rightLinks.map((link) => (
                <button type="button" key={link.path} onClick={() => handleNavigate(link.path)} style={{ fontSize: '13px', fontWeight: 500, padding: '0 8px', background: 'none', border: 'none', cursor: 'pointer', transition: 'color 0.2s', fontFamily: 'Manrope, sans-serif', color: isActive(link.path) ? 'var(--gold, #f47b20)' : 'rgba(255,255,255,0.7)' }}>{link.label}</button>
              ))}
              <button type="button" style={{ fontSize: '13px', fontWeight: 500, padding: '6px 12px', borderRadius: '4px', background: 'transparent', cursor: 'pointer', fontFamily: 'Manrope, sans-serif', color: 'rgba(255,255,255,0.7)', border: '1px solid rgba(255,255,255,0.2)' }}>Client Login</button>
              <button type="button" onClick={handleOpenExpert} style={{ fontSize: '13px', fontWeight: 500, padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontFamily: 'Manrope, sans-serif', background: 'rgba(244,123,32,0.15)', border: '1px solid rgba(244,123,32,0.4)', color: 'var(--gold, #f47b20)' }}>Talk to Expert</button>
              <button type="button" onClick={handleOpenQuote} style={{ fontSize: '13px', fontWeight: 700, padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontFamily: 'Manrope, sans-serif', background: 'var(--gold, #f47b20)', color: 'var(--navy, #0a192f)' }}>Get a Quote</button>
            </div>
          )}

          {/* Mobile Hamburger */}
          {!isDesktop && (
            <button type="button" onClick={() => setMobileOpen((prev) => !prev)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', padding: '8px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} aria-label="Toggle navigation menu" aria-expanded={mobileOpen}>
              <div style={{ width: '20px', height: '2px', backgroundColor: '#ffffff', marginBottom: '4px' }} />
              <div style={{ width: '20px', height: '2px', backgroundColor: '#ffffff', marginBottom: '4px' }} />
              <div style={{ width: '20px', height: '2px', backgroundColor: '#ffffff' }} />
            </button>
          )}
        </div>

        {!isDesktop && mobileOpen && (
          <div style={{ padding: '0 24px 16px 24px', background: 'rgba(0,0,0,0.98)' }}>
            {[...navLinks, ...rightLinks].map((link) => (
              <button type="button" key={link.path} onClick={() => handleNavigate(link.path)} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 0', fontSize: '14px', fontWeight: 500, background: 'none', border: 'none', cursor: 'pointer', borderBottom: '1px solid rgba(255,255,255,0.07)', fontFamily: 'Manrope, sans-serif', color: isActive(link.path) ? 'var(--gold, #f47b20)' : 'rgba(255,255,255,0.8)' }}>{link.label}</button>
            ))}

            <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
              {/* Mobile Talk to Expert Button */}
              <button type="button" onClick={() => { handleOpenExpert(); setMobileOpen(false); }} style={{ flex: 1, padding: '8px 0', borderRadius: '4px', fontSize: '13px', fontWeight: 700, background: 'transparent', cursor: 'pointer', border: '1px solid var(--gold, #f47b20)', color: 'var(--gold, #f47b20)', fontFamily: 'Manrope, sans-serif' }}>Talk to Expert</button>

              {/* Mobile Get a Quote Button */}
              <button type="button" onClick={() => { handleOpenQuote(); setMobileOpen(false); }} style={{ flex: 1, padding: '8px 0', borderRadius: '4px', fontSize: '13px', fontWeight: 700, border: 'none', cursor: 'pointer', background: 'var(--gold, #f47b20)', color: 'var(--navy, #0a192f)', fontFamily: 'Manrope, sans-serif' }}>Get a Quote</button>
            </div>
          </div>
        )}
      </header>

      {/* Render modals locally using internal state fallbacks */}
      {internalExpertOpen && (<ExpertModal onClose={() => setInternalExpertOpen(false)} />)}
      {internalQuoteOpen && (<QuoteModal onClose={() => setInternalQuoteOpen(false)} />)}
    </>
  );
}